import React from "react";
import { CustomChips } from "../../../common/components";
import { translate } from "../../../common/providers";

export default function TabTitleCounter({ title, counter }) {
	return (
		<span>
			{title}
			&nbsp;
			<CustomChips
				color="info"
				label={translate(
					counter > 1
						? "consistency-check.tab-title-counter.unresolved"
						: "consistency-check.tab-title-counter-single.unresolved",
					{ counter }
				)}
			/>
		</span>
	);
}
